define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function BrowserFileSizeLimitFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    BrowserFileSizeLimitFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: BrowserFileSizeLimitFail,
        className: 'BrowserFileSizeLimitFail',
        radarName: 'fail_{SOURCE}_browser-file-size-limit',
        message: [
            'Браузер не поддерживает загрузку файлов более 4 ГБ.',
            '<a href="https://help.mail.ru/cloud_web/files/upload" rel="noopener" target="_blank">Подробнее</a>',
        ].join(' '),
    });

    module.exports = BrowserFileSizeLimitFail;
});
